moduleAlert = angular.module('create.section.controller', [])

moduleAlert.controller 'CreateSectionModal', ["$scope", "$state", "$rootScope", "$modalInstance", "Restangular", "$stateParams", "Section", "$window", "allSections", "FileUploader", ($scope, $state, $rootScope, $modalInstance, Restangular, $stateParams, Section, $window, allSections, FileUploader) ->

  # Close modal

  $scope.close = ->
    $modalInstance.dismiss "close"

  $scope.loadTags = (query) ->
    Restangular.all("/sections/tags?q=#{query}").getList()

  $scope.loadColorTags = (query) ->
    Restangular.all("/sections/color_tags?q=#{query}").getList()

  $scope.section = {disabled: true}

  # Preview web uploader

  $scope.sectionPreviewUploader = new FileUploader(
    url: Restangular.configuration.baseUrl+"/sites/#{$state.params.siteId}"
    autoUpload: false
    method: "PUT"
    alias: "preview"
    headers : {
      'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
    }
  )

  $scope.sectionPreviewUploader.onAfterAddingFile = (item) ->
    types = ["image/jpeg", "image/png"]
    if item.file.type not in types
      alert("The file must be png or jpg")
      return false

  $scope.sectionPreviewUploader.onSuccessItem = (fileItem, response, status, headers) ->
    $scope.sectionPreviewUploader.clearQueue()
    return

  $scope.sectionPreviewUploader.onErrorItem = (fileItem, response, status, headers) ->
    return

  setUploadUrls = (sectionId) ->
    $scope.sectionPreviewUploader.queue.forEach (item) ->
      item.url = Restangular.configuration.baseUrl+"/sections/#{sectionId}"

  # Create section fn

  $scope.create = (createSectionForm, section) ->
    return false if createSectionForm.$invalid
    $scope.creating = true
    section.tags = _.map section.tags, (tag) ->  tag.name
    section.tags = section.tags.join(",")
    section.colors = _.map section.colors, (tag) ->  tag.text
    Section.createPublic(section).then (sectionData) ->
      setUploadUrls sectionData.id
      $scope.sectionPreviewUploader.uploadAll()
      $scope.close()
      $scope.creating = false
      allSections.push sectionData
    , ->
      $scope.creating = false



]



// WEBPACK FOOTER //
// ./src/app/editor/section_settings/create.controller.coffee